import React from 'react';
import {Grid} from "@material-ui/core";
import GenericDialog from "../dialog/GenericDialog";
import ProposalTabs from "../../pages/client/Enrollment/component/ProposalTabs";
import {noop} from "../../utils/commonUtils";
import { CallingFromObject } from "../../constants";


type NoConfirmProposalProps = {
    activeProposalTab: number,
    onClose: Function | any,
    openProposalPdf?: string,
    proposalPdf: any,
    setActiveProposalTab: Function,
    setEnableActions: Function,
    title: string,
    clientPolicyId?:string
    userId?:string
};

const NoConfirmProposal: React.FC<NoConfirmProposalProps> = (props) => {
    const {
        activeProposalTab,
        onClose,
        openProposalPdf,
        proposalPdf,
        setActiveProposalTab,
        title,
        clientPolicyId,
        userId
    } = props;

    console.info({openProposalPdf, proposalPdf});

    return (
            <React.Fragment>
                <GenericDialog
                        aria-describedby="no-confirm-propsal-dialog"
                        aria-labelledby="no-confirm-propsal-dialog"
                        content={
                            (
                                    <Grid container justify="center" spacing={2}>
                                        <ProposalTabs
                                                userId={userId}
                                                callingFrom={CallingFromObject.GIFTOR_RECIPIENT}
                                                clientPolicyId={clientPolicyId}
                                                activeProposalTab={activeProposalTab}
                                                callBack={() => noop()}
                                                proposalObjArr={proposalPdf}
                                                setActiveProposalTab={setActiveProposalTab}
                                        />
                                    </Grid>
                            )
                        }
                        fullWidth
                        keepMounted
                        maxWidth="lg"
                        onClose={onClose}
                        // onOutsideClick={onClose}
                        open={!!proposalPdf}
                        title={title}
                />
            </React.Fragment>
    );
};

export default NoConfirmProposal;
